import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const SingleCard = styled(Flex)`
  background: ${props => props.background};
  padding: ${props => props.padding};
  width: ${props => props.width};
  height: ${props => props.height || 'auto'};
  border: ${props => props.borderColor};
  border-radius: 10px;
  cursor: ${props => (props.isClickable ? 'pointer' : 'default')};
  
  &:hover {
    box-shadow: none;
  }
`


export const CardValue = styled.div`
  font-size: ${FONT.F_LG};
  font-weight: ${FONT.FW_600};
  color: ${props => (props.isSelected ? COLORS.PRIMARY : COLORS.TEXT_HIGH)};
  white-space: nowrap;
 margin-top: ${props => (props.isSlim ? '0' : '5px')};
  margin-left: ${props => (props.isSlim ? 'auto' : '0')};
`

export const CardText = styled.div`
  font-size: ${FONT.F_XS};
  font-weight: ${FONT.FW_400};
  color: ${props => (props.isSelected ? COLORS.PRIMARY : COLORS.TEXT_MEDIUM)};
  margin-left: 8px;
`

export const IconTextContainer = styled.div`
  display: flex;
  align-items: center;
`

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 8px;
`

export const CardValueLight = styled.div`
  font-size: 11px;
  font-weight: 400;
  color: ${COLORS.TEXT_MEDIUM};
  margin-bottom: 2px;
`

export const CardValueBig = styled.div`
  font-size: 22px;
  font-weight: 700;
  color: ${props => props.textColor || (props.isSelected ? COLORS.PRIMARY : COLORS.TEXT_HIGH)};
  margin-top: 4px;
`